var exports = {
  "kL": "InboxPopout.module__container___c0RCcE",
  "QZ": "InboxPopout.module__containerWithSidebar___c0RCcE",
  "pz": "InboxPopout.module__sidebar___c0RCcE",
  "G9": "InboxPopout.module__sidebarTabList___c0RCcE",
  "NP": "InboxPopout.module__sidebarFooterActions___c0RCcE",
  "jR": "InboxPopout.module__sidebarActionButton___c0RCcE",
  "M6": "InboxPopout.module__mainPanel___c0RCcE",
  "yt": "InboxPopout.module__sidebarTab___c0RCcE",
  "yR": "InboxPopout.module__tabActive___c0RCcE",
  "DF": "InboxPopout.module__tabInactive___c0RCcE",
  "Qs": "InboxPopout.module__content___c0RCcE",
  "Lj": "InboxPopout.module__tabContent___c0RCcE",
  "Bx": "InboxPopout.module__iconSmall___c0RCcE",
};

module.exports = exports;
